'use client'

import React from 'react'

import { useChangeBaseColor } from '@/hooks/useChangeBaseColor'
import UtmHandler from '@/libs/UtmHandler'

import { IProduct, IPromotion } from '../../types/schema'
import EGiftCartProductCard from './eGift_Cart_ProductCard'

import '@/styles/components/_template_eGift_Cart.scss'

interface EGiftCartProps {
  promotionData: IPromotion
  products?: IProduct[]
}

const Template_EGift_Cart: React.FC<EGiftCartProps> = ({ promotionData, products }) => {
  const displayProducts = products || promotionData.products || []
  useChangeBaseColor('bg-theme-light')

  //__ACCESS UNDEFINED PROPERTY
  const buyGiftUrl = (promotionData as any).buy_gift_url || ''

  //__FALLBACK IMAGE
  const promotionImage = `${process.env.NEXT_PUBLIC_API_GATEWAY}/${promotionData.promotion_img || '/images/placeholder.jpg'}`

  return (
    <div className='e-gift-cart'>
      <UtmHandler />

      {/* HEADER SECTION */}
      <header className='e-gift-header'>
        {promotionData.promotion_lhead && (
          <h1 className='primary-heading'>{promotionData.promotion_lhead}</h1>
        )}
      </header>

      {/* Main Image */}
      {promotionData.promotion_img && (
        <div className='promotion-image-container'>
          <img
            src={promotionImage}
            alt={promotionData.promotion_lhead || 'Gift Card Promotion'}
            className='promotion-image'
          />
        </div>
      )}

      {/* Title Bar - Similar to eGift_Green */}
      {/* {promotionData.promotion_rhead && (
        <div className='title-bar'>
          <h2 className='title-text'>{promotionData.promotion_rhead}</h2>
        </div>
      )} */}

      {/* Content Card */}
      <div className='content-card'>
        <div className='card-inner'>
          {/* Top Details Section */}
          {promotionData.promotion_tdetail && (
            <section className='promotion-top-details'>
              <div
                className='content-wrapper'
                dangerouslySetInnerHTML={{ __html: promotionData.promotion_tdetail }}
              />
            </section>
          )}

          {/* Products Section */}
          {displayProducts && displayProducts.length > 0 && (
            <section className='promotion-products'>
              <div className='products-grid'>
                {displayProducts.map((product, index) => (
                  <EGiftCartProductCard
                    key={`product-${product.id || product.pd_id}-${index}`}
                    product={product}
                    buy_gift_url={buyGiftUrl}
                    index={index}
                  />
                ))}
              </div>
            </section>
          )}

          {/* Bottom Details Section */}
          {promotionData.promotion_bdetail && (
            <section className='promotion-bottom-details'>
              <div
                className='content-wrapper'
                dangerouslySetInnerHTML={{ __html: promotionData.promotion_bdetail }}
              />
            </section>
          )}
        </div>
      </div>
    </div>
  )
}

export default Template_EGift_Cart
